import React, { useEffect, useState } from 'react';
import PCNListingTable from './PCNListingTable';
import { useAlertStore } from 'src/hooks/Alert';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { Tooltip } from 'src/component/Tooltip';
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import System from 'src/helper/system';
import Constants from 'src/support/Constants';
import Helper from 'src/support/Helper';

const PCNTabContent = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ PCNAlertListingByType }, fetch] = useAlertStore();
    const [{ }, { }, { clear_all_filter }] = useFilterSelectionStore();

    const [search, setSearch] = React.useState('')
    const [keyword, setKeyword] = React.useState('')
    const [filter, setFilter] = React.useState('')
    const [listObj, setListObj] = useState({
        sortBy: '',
        sortOrder: '',
    });

    const setExportParams = (keyword, search, filter, listObj) => {
        setKeyword(keyword);
        setSearch(search);
        setFilter(filter);
        setListObj({ ...listObj })
    }

    useEffect(() => {
        const getList = async () => {
            await clear_all_filter();
        };
        getList();
    }, []);

    const exportData = async () => {
        let params = {
            startRow: 0,
            notificationType: Constants.alertTypes.PCN,
            searchType: search,
            keyword,
            filterBy: filter,
            sortBy: listObj.sortBy ? listObj.sortBy : "",
            sortOrder: listObj.sortOrder ? listObj.sortOrder : ""
        }
        const response = await fetch.export_alert_data(params)
        
        
        if (response) {
            Helper.downloadFileFromRes(response, 'PCN.xlsx')
            showDownloadMessage();
        }
    };

    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success')
    }

    const renderTooltip = (props) => (
        <div>
            Avnet provides Supplier notifications to our customers as a valuable service. Customers who are subscribed
            thru our notification process will receive an email notification for all parts within their Parts of
            Interest (POI) which is made up of Order History (2 years) and our Customer Part Number to MFG Part cross
            reference database. Notifications are identified as either a Product Change Notice (PCN) or an End of Life
            (EOL).Notifications with a Last Time Buy (LTB) date are an EOL and if there is no LTB date then the notice
            is a PCN. LTB reminder notices are also sent within 6 weeks of the LTB date. LTB notifications are not a new
            notice and just serve as a reminder of the original EOL notification so that LTB orders can be placed if
            needed.
        </div>
    );

    return (
        <>
            <div id="tab1" className="tab-pane show active table-container">

                <div className="total-section dashboard-hide">
                    Total PCN Alerts:&nbsp;
                    {__check(['ALERT_API_CALL'], { inline: true }).render}
                    {!__check(['ALERT_API_CALL']).status &&
                        <span>{PCNAlertListingByType && PCNAlertListingByType.totalAlertList}</span>
                    }
                </div>

                <div className="d-flex justify-content-between flex-wrap align-items-center dashboard-hide">
                    <div className="sub-section mb-0">
                    </div>
                    <ul className="quick-links ps-0 pb-2 mb-0">
                        <Tooltip
                            position={'left center'}
                            opener={() => (
                                <li>
                                    <a href={void (0)} data-placement="bottom" data-toggle="tooltip"
                                        data-html="true" data-original-title="<p>PCN/EOL/ LTB notifications are sent based on our Parts of interest table which includes QUOCPN and (2 years) Sale order history- parts purchased from Avnet and any open backlog, Stock Res and indirect orders.<br><br>
                                      We do map Embedded EOL and PCN notices  like we do for SEMI and IP&E parts.   EOL and PCN notices are retained in our database indefinitely.  There is no process to automatically delete or archive this data.   At this time, we are unable to limit sending EOL/PCN  on a specific ship plate.
                                    </p>"><i className="fa fa-info-circle me-2 text-black" aria-hidden="true" />
                                        <span className="text-blue">Information</span></a>
                                </li>
                            )}
                            content={() => (
                                renderTooltip()
                            )}
                        />
                        <li>
                            {!__check(['EXPORT_ALERT_API_CALL']).status &&
                                <div className="text-blue" style={{
                                    cursor: 'pointer'
                                }} onClick={exportData}><i className="file-export-icon me-2 text-black" />Export
                                </div>}
                            {__check(['EXPORT_ALERT_API_CALL'], { inline: true }).render}
                        </li>
                    </ul>
                </div>

                <PCNListingTable setExportParams={(keyword, search, filter, listObj) => setExportParams(keyword, search, filter, listObj.sortBy, listObj.sortOrder)} />

            </div>
            <div id="tab2" className="tab-pane fade table-container">No Data Found</div>
        </>
    );
}

export default PCNTabContent;